/**
 * Lobby "popular games" — slots ranked by svc-bet on their real RTP over the
 * last 24h of play on this brand, topped up from the catalog when too few have
 * enough play to rank.
 */
import { apiFetch } from '../../lib/api/client.js';
import { POPULAR_GAMES_SHOWN, pickPopularGames } from '@b1fr0st/contracts/popular-games';
import type { Game } from './api.js';

export interface HotGame {
  gameId: string;
  /** Percent, 2dp; may exceed 100 over the window. */
  rtp: number;
  rounds: number;
}

export interface HotGamesResponse {
  items: HotGame[];
  windowHours: number;
}

export const HOT_GAMES_QUERY_KEY = ['games', 'hot'] as const;
export const HOT_GAMES_SHOWN = POPULAR_GAMES_SHOWN;

export function fetchHotGames(): Promise<HotGamesResponse> {
  return apiFetch<HotGamesResponse>('/hot-games');
}

/** A catalog game with the measured RTP it was ranked on, when it was ranked. */
export type HotGameCard = Game & { rtpLive: number | null };

/**
 * The cards to show, by the rule svc-game also asks tiles for
 * (`pickPopularGames`): ranked games first, in the server's order, then catalog
 * slots by catalog RTP (then `hot` tag) until `limit`, matched on game code.
 */
export function pickHotGames(hot: HotGame[], slots: Game[], limit = HOT_GAMES_SHOWN): HotGameCard[] {
  return pickPopularGames(hot, slots.filter((g) => g.status === 'active'), limit).map(({ game, ranked }) => ({
    ...game,
    rtpLive: ranked?.rtp ?? null,
  }));
}
